/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CatalogItemFromJSON, CatalogItemToJSON, DestinationFromJSON, DestinationToJSON, RoomStringFromJSON, RoomStringToJSON, StepFromJSON, StepToJSON, TutorialAnchorFromJSON, TutorialAnchorToJSON, TutorialElementFromJSON, TutorialElementToJSON, TutorialThemeFromJSON, TutorialThemeToJSON, } from './';
export function TutorialFromJSON(json) {
    return TutorialFromJSONTyped(json, false);
}
export function TutorialFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': !exists(json, 'version') ? undefined : json['version'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'anchor': !exists(json, 'anchor') ? undefined : TutorialAnchorFromJSON(json['anchor']),
        'steps': !exists(json, 'steps') ? undefined : (json['steps'].map(StepFromJSON)),
        'start': !exists(json, 'start') ? undefined : DestinationFromJSON(json['start']),
        'theme': !exists(json, 'theme') ? undefined : TutorialThemeFromJSON(json['theme']),
        'strings': !exists(json, 'strings') ? undefined : (json['strings'].map(RoomStringFromJSON)),
        'catalog': !exists(json, 'catalog') ? undefined : (json['catalog'].map(CatalogItemFromJSON)),
        'elements': !exists(json, 'elements') ? undefined : (json['elements'].map(TutorialElementFromJSON)),
    };
}
export function TutorialToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
        'id': value.id,
        'anchor': TutorialAnchorToJSON(value.anchor),
        'steps': value.steps === undefined ? undefined : (value.steps.map(StepToJSON)),
        'start': DestinationToJSON(value.start),
        'theme': TutorialThemeToJSON(value.theme),
        'strings': value.strings === undefined ? undefined : (value.strings.map(RoomStringToJSON)),
        'catalog': value.catalog === undefined ? undefined : (value.catalog.map(CatalogItemToJSON)),
        'elements': value.elements === undefined ? undefined : (value.elements.map(TutorialElementToJSON)),
    };
}
//# sourceMappingURL=Tutorial.js.map